import { z } from "zod";
import { DTODesignSystem } from "./design-system";
import { DTOWorkspace } from "../workspaces";

export const DTOUserDesignSystemsResponse = z.object({
  designSystems: DTODesignSystem.array(),
  workspaces: DTOWorkspace.array(),
});

export type DTOUserDesignSystemsResponse = z.infer<typeof DTOUserDesignSystemsResponse>;
